import type { InjectionKey } from 'vue';
import type { I18n } from '@/i18n';

export const languageInjectionKey = Symbol('language') as InjectionKey<string>;

export const cookiesInjectionKey = Symbol('cookies') as InjectionKey<string>;

export const i18nInjectionKey = Symbol('i18n') as InjectionKey<I18n>;
